module.exports = __webpack_public_path__ + "img/piscina.67819bb5.gif";